import { IS3FileMetaData } from "../typings/s3-file-metadata";

export function downloadS3FileFromSignedURL(fileMetaData: IS3FileMetaData) {
  const headers = {
    "Content-Type": fileMetaData.contentType,
  };
  fetch(fileMetaData.url, { headers })
    .then((response) => {
      if (response.status === 200) return response.blob();
      else throw response;
    })
    .then((data) => {
      const newBlob = new Blob([data]);
      const link = document.createElement("a");
      const payloadUrl = window.URL.createObjectURL(new File([newBlob], fileMetaData.fileName));

      link.href = payloadUrl;
      link.download = `${fileMetaData.fileName}${getFileExtFromContentType(
        fileMetaData.contentType
      )}`;
      link.click();
    })
    .catch((error) => {
      throw error;
    });
}

export function viewS3FileDocument(data: any) {
  const payload = data;
  const file = new Blob([payload], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL, "_blank");
}
function getFileExtFromContentType(contentType: string) {
  let fileExtension = "";
  switch (contentType) {
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      fileExtension = ".xlsx";
      break;
    case "application/pdf":
      fileExtension = ".pdf";
      break;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      fileExtension = ".docx";
      break;
    default:
  }
  return fileExtension;
}
